<template>
  <div class="highlights-sns-balloon-parts">
    <p
      class="highlights-sns-balloon-parts__message"
      v-html="$tc('RaceVideoPage.highlights.comment.snsNote')"
    ></p>
  </div>
</template>

<script lang="ts">
import { defineComponent } from '@vue/composition-api'

export default defineComponent({
  name: 'HighlightsSnsBalloonParts',
})
</script>

<style scoped lang="scss">
.highlights-sns-balloon-parts {
  position: relative;
  padding: 4px 6px 3px;
  background-color: rgba(#73ffdd, 0.2);
  border-radius: 14px;

  &__message {
    font-size: 11px;
    color: #73ffdd;
    line-height: 1.2;
    letter-spacing: 0.04em;
    white-space: nowrap;
    text-align: center;
  }
}
</style>
